<template>
  <div>
    <!-- //최상단 -->
    <div class="header-in" style="border: none;">
      <div class="header-container">
          <div class="inner">
            <div class="header-branding">
              <h2 class="logo">
                <a href="/" class="logo-main" alt="차세대정보보안인증원">
                  <span class="sr-only">차세대정보보안인증원</span>
                </a>
              </h2>

              <button type="button" class="btn-navi all" aria-controls="mobile-nav" @click="openMobileMenu()">
                <span class="sr-only">전체메뉴</span>
              </button>
            </div>
          </div>
        </div>

      <div class="head_fr">
        <!-- 메뉴영역 -->
        <nav class="krds-main-menu">
          <div class="inner">
            <ul class="gnb-menu" aria-label="메인 메뉴">
              <li v-for="(item, index) in topMenu" :key="index">
                <button v-if="item.hiddenYn != 'Y'"  @click="doMouseEnter(item,index)" :key="index" type="button" class="gnb-main-trigger  curs-p" data-trigger="gnb" :class="[item.rinkClass || '', item.menuTypeCd === 'CMS007.link' ? 'direct-icon' : '']">{{$sanitize($t(item.menuNm))}}</button>
                <!-- gnb-toggle-wrap -->
                <div class="gnb-toggle-wrap" :class="item.rinkClass!= null?item.rinkClass:['']" >
                  <!-- gnb-main-list -->
                  <div class="gnb-main-list" style="min-height: 0px;">
                    <!-- gnb-sub-list -->
                    <div class="gnb-sub-list single-list between">
                      <div class="gnb-sub-content">
                        <h2 class="sub-title">
                          <a class="curs-d">{{$sanitize($t(item.menuNm))}}</a>
                        </h2>
                        <div class="gnb-depth-wrap">
                          <ul class="depth-2 gnb-depth-grid">
                            <li v-for="(item2, index2) in item.subMenu " :key="`${index2}_div`">
                              <a class="curs-p" v-if="item2.hiddenYn != 'Y'" @click="doSubLink(item2)" :class="{direct: item2.menuTypeCd === 'CMS007.link' && item2.link.charAt(0) !== '/'}"><span>{{$sanitize($t(item2.menuNm))}}</span></a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <!-- //gnb-sub-list -->
                  </div>
                  <!-- //gnb-main-list -->
                </div>
                <!-- //gnb-toggle-wrap -->
              </li>
            </ul>
          </div>
        </nav>
        
      </div>
      
    </div>
    <!-- is-backdrop is-open -->
    <div id="mobile-nav" class="krds-main-menu-mobile is-gnb-mobile" :class="{'is-open' : isMobileMenuOpen, 'is-backdrop' : isBackdrop}" >
      <div class="gnb-wrap">
        <!-- gnb-body -->
        <div class="gnb-body" ref="gnbBody">
          <!-- gnb-menu -->
          <div class="gnb-menu">
            <div class="menu-wrap">
              <ul>
                <li v-for="(item, index) in topMenu" :key="index" :ref="'menuItem'">
                  <a v-if="item.hiddenYn != 'Y'" :data-menu-id="item.menuId" @click="doMouseEnterM(item,index)" :key="index" class="gnb-main-trigger curs-p" :class="{ active: activeIndex === index }" :aria-selected="activeIndex+1 === index ? 'true' : 'false'">
                    {{$sanitize($t(item.menuNm))}}
                  </a>
                </li>
              </ul>
            </div>
            <div class="submenu-wrap">
              <div v-for="(item, index) in topMenu" :key="index" class="gnb-sub-list" id="mGnb-anchor1" ref="subTitles">
                <h2 class="sub-title"><a :class="{'direct-icon': item.menuTypeCd === 'CMS007.link'}" href="javascript:void(0);" @click="item.menuTypeCd === 'CMS007.link' && doTopLink(item)" :data-menu-id="item.menuId">{{$sanitize($t(item.menuNm))}}</a></h2>
                <ul class="depth-2">
                  <li v-for="(item2, index2) in item.subMenu " :key="`${index2}_div`">
                    <a class="curs-p" v-if="item2.hiddenYn != 'Y'" @click="doSubLink(item2)" :class="{direct: item2.menuTypeCd === 'CMS007.link' && item2.link.charAt(0) !== '/'}"><span>{{$sanitize($t(item2.menuNm))}}</span></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- //gnb-body -->
        <!-- gnb-close -->
        <button type="button" class="krds-btn medium icon" id="close-nav" @click="closeMobileMenu()">
          <span class="sr-only">전체메뉴 닫기</span>
          <i class="svg-icon ico-popup-close"></i>
        </button>
        <!-- //gnb-close -->
      </div>
    </div>
    <!-- -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    snsLinkList: {
      type: Array,
      default: () => []
    },
    isPCMenuOpen: { 
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'popupInfo',
      'subMenuBreadcrumb'
    ]),
  },
  data() {
    return {
      isMobile: false,
      topMenu: [],
      rinkClass: [],
      searchParam: {
        ck_weather_str : '',
      },
      arr_day1: [],
      arr_day2: [],
      arr_day3: [],
      icon: '',
      isShow: false,
      isWait: false,
      totalMenuCnt: 0,
      activeIndex: null,
      isMobileMenuOpen: false,
      isBackdrop:false,
      treeData: [],
    }
  },
  created(){
    this.rinkClass = [''];
    this.doTopMenuList();
  },
  watch: {
    activeIndex(newVal) {
      const menuItems = this.$refs.menuItem;
      const el = this.$el.querySelector(`.gnb-sub-list a[data-menu-id="${newVal}"]`);
      const gnbBody = this.$refs.gnbBody;
      if (gnbBody) {
        const top = el.getBoundingClientRect().top - gnbBody.getBoundingClientRect().top + gnbBody.scrollTop;
      gnbBody.scrollTo({
        top: top, 
        behavior: 'smooth'});
      }else{
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
  },
  methods: {
    doMouseEnterM(item, index) {
      this.activeIndex = index;
    },
    openMobileMenu(){
      this.isMobileMenuOpen= !this.isMobileMenuOpen;
      this.isBackdrop = !this.isBackdrop;
      document.body.style.overflow = 'hidden';
    },
    closeMobileMenu(){
      this.isMobileMenuOpen= !this.isMobileMenuOpen;
      this.isBackdrop = !this.isBackdrop;
      document.body.style.overflow = '';
    },
    // 전체메뉴 조회
    doTopMenuList() {
      this.$tran('/site/external/main/selectTopMenuList','').then(response => {
        this.topMenu = response.data.treeData;
        this.totalMenuCnt = response.data.totalMenuCnt;
        this.$store.dispatch('setTreeData', this.topMenu);
      })  
    },
    // 대메뉴 링크
    doTopLink(item){
      const menuTypeCd = item.menuTypeCd;
      const subLink = item.link;
      const param = {};
      const firstSubMenu = Object.entries(item?.subMenu)[0];
      if(firstSubMenu != null && firstSubMenu.length > 0){
        param.query = {menuId: firstSubMenu[0], upMenuId: item.menuId, s0:firstSubMenu[1].firstGrpCd};  
      }else{
        param.query = {menuId: item.menuId, upMenuId: item.menuId, s0:null};
      }
      if(menuTypeCd == 'CMS007.content') {
        param.name = 'content';
      }else if(menuTypeCd == 'CMS007.link' && subLink.endsWith('/isoti')) {
        window.open(subLink, "_blank");
        return
      }else{
        let link = item?.link.trimStart();
        
        // 링크내용이 있을경우
        if(link != null && link != '') {  
          const contentLink = link.charAt(0) == '/';

          if(contentLink) { // 내부 컨텐츠 링크
            param.path = link;
          }else{  // 외부링크
            window.open(link, "_blank");
            return
          }
        }else{
          link = '/';
        }

        param.path=link;
        param.query={};
      }
      
      const routeQuery = JSON.stringify(this.$route.query)
      const nextQuery = JSON.stringify(param.query)
      param.params = {isFirst:item.menuId}

      if(routeQuery != nextQuery || menuTypeCd =='CMS007.link'){
        this.$router.push(param)
      }
    },
    // 하위메뉴 링크
    doSubLink(item){
      this.closeMobileMenu();
      const menuTypeCd = item.menuTypeCd;
      const subLink = item.link;
      const param = {};
      param.query = {menuId: item.menuId, upMenuId: item.upMenuId, s0:item.firstGrpCd};
      document.body.classList.remove('is-gnb-web');
      this.toggleScrollbar(false);

      if(menuTypeCd == 'CMS007.content') {
        param.name = 'content';
      }else if(menuTypeCd == 'CMS007.link' && link.endsWith('/isoti')) {
        window.open(link, "_blank");
        return
      }else{
        let link = item?.link.trimStart();
        
        // 링크내용이 있을경우
        if(link != null && link != '') {  
          const contentLink = link.charAt(0) == '/';

          if(contentLink) { // 내부 컨텐츠 링크
            param.path = link;
          }else{  // 외부링크
            window.open(link, "_blank");
            return
          }
        }else{
          link = '/';
        }

        param.path=link;
        param.query={};
      }
      
      const routeQuery = JSON.stringify(this.$route.query)
      const nextQuery = JSON.stringify(param.query)
      param.params = {isFirst:item.menuId}

      if(routeQuery != nextQuery || menuTypeCd =='CMS007.link'){
        this.$router.push(param)
      }

      this.isShow = false;

      Object.keys(this.topMenu).forEach((e) => {
        this.$set(this.topMenu[e], 'rinkClass', )
        this.$emit("update:isPCMenuOpen", false);
      }) 
    },
    toggleScrollbar(isEnabled) {
      const isScrollNeeded = document.body.scrollHeight > window.innerHeight;
      document.body.classList.toggle("hasScrollY", isEnabled && isScrollNeeded);
    },
    doMouseEnter(item,index) {
      const menuTypeCd = item.menuTypeCd;
      const subLink = item.link;
      const currentDomain = window.location.origin;
      if (menuTypeCd === 'CMS007.link') {
        if (subLink.startsWith('/')) {
          window.location.href = subLink;
        } else {
          const newWin = window.open(subLink, "_blank");
          if (newWin) newWin.opener = null;
        }
        return;
      }
      Object.keys(this.topMenu).forEach((e) => {
        if(index != e){
          this.$set(this.topMenu[e], 'rinkClass', )
        }else{
          const isCurrentlyOpen = item.rinkClass && item.rinkClass.includes('is-open');
          if(undefined || !isCurrentlyOpen){
            this.$set(item, 'rinkClass', ['is-open', 'active'])
            const isOpen = true;
            this.$emit("update:isPCMenuOpen", true);
            document.body.classList.toggle("is-gnb-web", isOpen);
            this.toggleScrollbar(true);
          } else {
            this.$set(this.topMenu[e], 'rinkClass', )
            const isOpen = false;
            this.$emit("update:isPCMenuOpen", false);
            document.body.classList.toggle("is-gnb-web", isOpen);
            this.toggleScrollbar(false); 
          }
        }
      }) 
    },
  }
}
</script>
